/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */

import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AbstractControl, ReactiveFormsModule} from '@angular/forms';
import {BaseFormFieldDirective} from '../../base-form-field.directive';
import {IxModule} from '@siemens/ix-angular';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {FieldLabelComponent} from '../field-label/field-label.component';

@Component({
  selector: 'app-number-input',
  imports: [
    CommonModule,
    IxModule,
    TranslateModule,
    ReactiveFormsModule,
    FieldLabelComponent,
  ],
  templateUrl: './number-input.component.html',
  styleUrl: '../input-components.scss',
})
export class NumberInputComponent extends BaseFormFieldDirective {
  override readonly translate = inject(TranslateService);

  override onControlValueInitialized(): void {
    super.onControlValueInitialized();
    // ix-number-input stepper buttons cannot increment from an untouched empty-string value.
    if (this.control.value === '') {
      this.control.setValue(null, {emitEvent: false});
    }
  }

  translateUnit(preLabel: string, unit: string): string {
    const translateValue = `${preLabel}.${unit}`;
    const translated = this.translate.instant(translateValue);
    if (translated === translateValue) {
      return unit;
    } else {
      return translated;
    }
  }

  override createCustomInvalidText(control: AbstractControl): string {
    if (
      control?.errors?.['pattern'] &&
      control?.errors?.['pattern'].requiredPattern === '^-?\\d*\\.?\\d*$'
    ) {
      return this.translate.instant('battery_pass.edit.errors.too_big_number');
    }
    return '';
  }
}
